import styles from './Modal.module.scss';
import { Icon } from '../Icon';
import { useRef } from 'react';
import { useOnClickOutside } from 'app/hooks';
import clsx from 'clsx';

interface Props {
  headerTitle?: string;
  component?: string | React.ReactNode;
  className?: string;
  isShown?: boolean;
  onClose?: () => void;
  isError?: boolean;
  wrapperClass?: string;
  closeByClickOutside?: boolean;
  componentClass?: string;
}

export const Modal = ({
  closeByClickOutside,
  component,
  headerTitle,
  className,
  isError,
  isShown = false,
  onClose,
  wrapperClass,
  componentClass,
}: Props) => {
  const modalRef = useRef<HTMLDivElement>(null);

  const clickOutsideHandler = () => {
    closeByClickOutside ? onClose?.() : null;
  };

  useOnClickOutside(modalRef, clickOutsideHandler);

  return (
    <div className={clsx(className, styles.root)} data-show={isShown}>
      <div className={clsx(wrapperClass, styles.modal)} data-error={isError} ref={modalRef}>
        <div className={styles.header}>
          <div className={styles.title}>{headerTitle}</div>
          {onClose && (
            <div onClick={onClose} className={styles.close}>
              <Icon name="close-16" size="16" />
            </div>
          )}
        </div>
        <div className={clsx(componentClass, styles.component_wrapper)}>{component}</div>
      </div>
    </div>
  );
};
